export const projects = [
  {
    id: 1,
    title: "Product Listing App",
    stack: "HTML, CSS, JavaScript",
    github: "https://github.com/Oluwamighty/product-listing",
    live: "https://product-listing-eight-zeta.vercel.app/",
    src: "assets/images/product list2.png",
    description: "A shopping cart system with full add-to-cart, increment/decrement, and order confirmation features, all in pure JavaScript! 🛒✨"
  },
  {
    id: 2,
    title: "Conference Ticket Generator",
    stack: "JavaScript, CSS",
    github: "https://github.com/Oluwamighty/ticket-generator",
    live: "https://conference-ticket-alpha.vercel.app/",
    src: "assets/images/conference.png",
    description: "A clean, modern web app for generating personalized tickets for Coding Conf 2025 — featuring image upload, responsive design, and smooth user experience"
  },
  {
    id: 3,
    title: "Browser Extension",
    stack: "JavaScript, CSS",
    github: "https://github.com/Oluwamighty/ticket-generator",
    live: "https://browser-extension-ivory.vercel.app/",
    src: "assets/images/browser-img.png",
    description: "A modern Browser Extensions Manager UI that allows users to view, activate, deactivate, and organize their extensions with a clean and responsive design."
  },
  {
    id: 4,
    title: "Weather App",
    stack: "JavaScript, CSS, API",
    github: "https://github.com/Oluwamighty/WeatherAppV2",
    live: "https://weather-app-v2-rho.vercel.app/",
    src: "assets/images/weather.jpg",
    description: "Weather Now — A modern, responsive weather dashboard that delivers real-time forecasts, hourly insights, and daily outlooks with a clean, user-friendly interface. Built to showcase dynamic data fetching, state management, and smooth UI interactions for an engaging user experience. 🌤️💻"
  },
  {
    id: 5,
    title: "Debih Solutions",
    stack: "JavaScript, CSS, API, React",
    github: "https://github.com/Oluwamighty/debih-app",
    live: "https://debih-app.vercel.app/",
    src: "assets/images/debih.jpg",
    description: "A portfolio website for Debih Solutions, a company that provides Electrical Engineering Services with the integration of AI Chatbot for customer service"
  }
];
